export default "__VITE_ASSET__DpXESSDn__"